import { MessageBar, MessageBarActions, MessageBarBody, mergeClasses } from "@fluentui/react-components";
import React, { FunctionComponent } from "react";

import { M365AlertProps } from "./M365Alert.types";
import { observer } from "mobx-react";
import { useM365AlertStyles } from "./M365Alert.styles";
import { useRootStore } from "Store/RootStore";

const M365AlertBase: FunctionComponent<M365AlertProps> = (props: M365AlertProps) => {
    const classNames = useM365AlertStyles();
    const { message, className, action, intent } = props;
    const { lastErrorCorrelationId } = useRootStore("LogStore");

    const correlationId = props.correlationId ?? lastErrorCorrelationId;

    let errorMessage = "";
    if (props.intent === "error" && correlationId !== "") {
        errorMessage = ` (CorrelationId: ${correlationId})`;
    }

    const content =
        typeof message === "string" ? (
            message + errorMessage
        ) : (
            <>
                {message} <span>{errorMessage}</span>
            </>
        );

    const styles = intent === "info" ? mergeClasses(classNames.root, className) : className;

    return (
        <MessageBar className={styles} intent={intent} role="alert">
            <MessageBarBody>{content}</MessageBarBody>
            <MessageBarActions containerAction={action} />
        </MessageBar>
    );
};

export const M365Alert = observer(M365AlertBase);
M365Alert.displayName = "M365Alert";
